import { render } from "./SnippetPagination.vue?vue&type=template&id=eb0667ac"
import script from "./SnippetPagination.vue?vue&type=script&lang=js"
export * from "./SnippetPagination.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\vscode_playground\\WeinfinderV3\\weinfinder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__